import { render } from "./DownArrow.vue?vue&type=template&id=0e6d3d42"
import script from "./DownArrow.vue?vue&type=script&lang=js"
export * from "./DownArrow.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/ccs-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__